import * as LeftSidebarContentAction from './LeftSidebarContent/actions';
import * as PopUpDetailsContent from './PopUpDetailsContent/actions';

export const CHANGE_DATE_RANGE = '@@CatDashboard/CHANGE_DATE_RANGE';
export const CHANGE_FILTER_TYPE = '@@CatDashboard/CHANGE_TYPE';
export const CHANGE_HELP_POPUP_STATE =
  '@@CkuLeftSidebarContent/CHANGE_HELP_POPUP_STATE';

export const change_date_range = date_range => ({
  type: CHANGE_DATE_RANGE,
  payload: date_range
});

export const change_filter_type = type => ({
  type: CHANGE_FILTER_TYPE,
  payload: type
});

export const change_help_popup_state = value => ({
  type: CHANGE_HELP_POPUP_STATE,
  payload: value
});

export const forward_fetch_by_selected_state = (id, selectedState) =>
  LeftSidebarContentAction.forward_fetch_by_selected_state(id, selectedState);

export const backward_fetch_by_selected_state = (id, selectedState) =>
  LeftSidebarContentAction.backward_fetch_by_selected_state(id, selectedState);

export const fetch_country_details = () =>
  LeftSidebarContentAction.fetch_country_details();

export const change_popup_details_view_state = value =>
  PopUpDetailsContent.change_popup_details_view_state(value);
